import React from "react";
import { ActivitiesFormDetailContainerStyled } from "./styled";
import { connect } from "react-redux";
import { withRouter } from "navigations/withRouter";
import { ROUTE_PATH } from "utils/constants/routePath";
import { userService } from "apiServices";
import { setReduxWallet } from "store/reducers/walletReducer";
import Linkify from "react-linkify";
import { withTranslation } from "react-i18next";
import { IMG_PATH } from "utils/constants/imgPath";
import QRCode from "react-qr-code";
import moment from "moment";
import {
  Buttons,
  Cards,
  Displays,
  Icons,
  Modals,
  Navigations,
  Headers,
} from "components";
import ImageSmooth from "components/Displays/ImageSmooth";

class ActivitiesFormDetailContainer extends React.Component {
  state = {
    isLoading: true,
  };

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    const { authenRedux, router } = this.props;
    let res = await Promise.all([
      userService.GET_ACTIVITY_FORM_DETAIL(router.params?.id),
      userService.GET_ACTIVITY_FORM_HISTORY_BY_ME_ACTIVITY(
        router.params?.id,
        authenRedux.member_type_active,
      ),
    ]);
    if (res && res[0].status === 200) {
      this.setState({
        data: res[0].data,
        activityRegisData: res[1].data ? res[1].data : false,
        isShowModal: false,
        isLoading: false,
        isBgLoading: false,
      });
    }
  };

  handleClickBack = () => {
    this.props.router.navigate(`${ROUTE_PATH.ACTIVITIES}`);
  };

  handleCloseModal = () => {
    this.setState({
      isShowModal: false,
      renderModal: false,
    });
  };

  handleViewRegistrationDetails = () => {
    const { router } = this.props;
    router.navigate(`${ROUTE_PATH.ACTIVITY_FORM}/preview/${router.params?.id}`);
  };

  handleActivityRegis = () => {
    const { router } = this.props;
    this.props.router.navigate(
      `${ROUTE_PATH.ACTIVITY_FORM}/${router.params?.id}/quiz/create/update`,
    );
  };

  handleEdit = (key, e) => {
    const { router } = this.props;
    this.props.router.navigate(
      `${ROUTE_PATH.ACTIVITY_FORM}/${router.params?.id}/quiz/${e._id}/${key}`,
    );
  };

  handleDownloadDoc = (e) => {
    const pdfPath = IMG_PATH + e; // ปรับ path ตามที่ต้องการ
    const link = document.createElement("a");
    link.href = pdfPath;
    link.setAttribute("download", "statistics.pdf"); // ตั้งชื่อไฟล์ที่ต้องการดาวน์โหลด
    link.setAttribute("target", "_blank");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  handleShowQrCode = (e) => {
    this.setState({
      renderModal: (
        <div className="qrcode_container">
          <div className="btn_close" onClick={this.handleCloseModal}>
            <Icons.Close />
          </div>
          <QRCode
            value={`${e.customer_ref_id},${e.activity_form_ref_id},${e._id},${
              e.member_type || "1"
            },2`}
            size={170}
          />
        </div>
      ),
      isShowModal: true,
    });
  };

  handleDelete = (e) => {};

  handleEditDataRequest = (e) => {
    const { router } = this.props;
    this.props.router.navigate(
      `${ROUTE_PATH.ACTIVITY_FORM}/${router.params?.id}/quiz/${e?._id}/request-edit/preview`,
    );
  };

  handleApproveAdminEdit = async (e) => {
    const { router } = this.props;
    this.props.router.navigate(
      `${ROUTE_PATH.ACTIVITY_FORM}/${router.params?.id}/quiz/${e?._id}/check-data/preview`,
    );
  };

  render() {
    const { t, i18n } = this.props;
    const {
      isLoading,
      isBgLoading,
      isShowModal,
      renderModal,
      data,
      activityRegisData,
    } = this.state;
    const DATE_BREADCRUMB = [
      {
        name: t("Home", { ns: "common" }),
        path: ROUTE_PATH.HOME,
      },
      {
        name: t("Activity News", { ns: "common" }),
        path: ROUTE_PATH.ACTIVITIES,
      },
    ];
    const isClosedRegistration =
      data &&
      data.registration_end_date &&
      moment(moment().format("YYYY-MM-DD HH:mm")).isAfter(
        data.registration_end_date && data.registration_end_time
          ? moment(data.registration_end_date).format("YYYY-MM-DD") +
              " " +
              data.registration_end_time
          : moment(data.registration_end_date)
              .endOf("day")
              .format("YYYY-MM-DD HH:mm"),
      );
    return (
      <ActivitiesFormDetailContainerStyled>
        <Displays.BGLoading visible={isBgLoading} />
        <div className="breadcrumb_layout">
          <Navigations.Breadcrumb data={DATE_BREADCRUMB} />
        </div>
        <div className="activity_container">
          <Headers.NewPageHeader
            title={"ACTIVITY : Online form"}
            sub_title={"กิจกรรม: แบบฟอร์มออนไลน์"}
          />
          {isLoading ? (
            <Displays.Loading />
          ) : (
            <>
              <div className="activity_wrap">
                <ImageSmooth
                  alt="activity"
                  src={
                    data.img
                      ? IMG_PATH + data.img
                      : "/assets/images/mockups/activities-1.jpg"
                  }
                  aspectRatio="1 / 1"
                />
              </div>
              <div className="activities_title">
                {i18n.language === "en" ? data.name_en : data.name_th}
              </div>
              <div className="activities_sub_article">
                <Linkify
                  componentDecorator={(decoratedHref, decoratedText, key) => (
                    <a target="blank" href={decoratedHref} key={key}>
                      {decoratedText}
                    </a>
                  )}
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html:
                        i18n.language === "en"
                          ? data.description_en
                          : data.description_th,
                    }}
                  />
                </Linkify>
              </div>
              {data.document && (
                <div className="doc_block">
                  <div className="doc_label">{data.document_name}</div>
                  <button
                    type="button"
                    className="doc_download"
                    onClick={() => this.handleDownloadDoc(data.document)}
                  >
                    <Icons.Download color="#4B1E78" /> {t("Download")}
                  </button>
                </div>
              )}
              {data.img2 && (
                <div className="img_position2">
                  <ImageSmooth
                    alt="activity"
                    src={
                      data.img2
                        ? IMG_PATH + data.img2
                        : "/assets/images/mockups/activities-1.jpg"
                    }
                    aspectRatio="1 / 1"
                  />
                </div>
              )}
              {!activityRegisData || data.is_active ? (
                data.registration_end_date && isClosedRegistration ? (
                  <div className="notice_close_regis">
                    {t("Registration Closed", { ns: "common" })}
                  </div>
                ) : (
                  <div className="btn_wrap">
                    {data.registration_start_date &&
                    moment().isBefore(
                      moment(
                        !data.registration_start_time
                          ? moment(data.registration_start_date)
                          : `${moment(data.registration_start_date).format(
                              "DD/MM/YYYY",
                            )} ${moment(
                              data.registration_start_time,
                              "HH:mm",
                            ).format("HH:mm")}`,
                        "DD/MM/YYYY HH:mm",
                      ),
                    ) ? (
                      <>
                        <div className="btn_view_registration_details_wrap">
                          <Buttons.BgStandard
                            theme_none_border
                            label={t("View the registration details", {
                              ns: "common",
                            })}
                            onClick={() => {
                              this.handleViewRegistrationDetails();
                            }}
                          />
                        </div>
                        <div className="notice_close_regis">
                          {!data.registration_start_time
                            ? t(
                                "Registration will open on the application start date",
                                { ns: "common" },
                              )
                            : t(
                                "Registration will open on \n{{date}} \nat {{time}}",
                                {
                                  ns: "common",
                                  date: moment(
                                    data.registration_start_date,
                                  ).format("DD MMMM YYYY"),
                                  time: moment(
                                    data.registration_start_time,
                                    "HH:mm",
                                  ).format("HH:mm"),
                                },
                              )}
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="btn_view_registration_details_wrap">
                          <Buttons.BgStandard
                            theme_none_border
                            prefixLabel="* "
                            label={t("View the registration details", {
                              ns: "common",
                            })}
                            onClick={() => {
                              this.handleViewRegistrationDetails();
                            }}
                          />
                        </div>
                        <Buttons.BgStandard
                          label={t("Register", { ns: "common" })}
                          onClick={() => {
                            this.handleActivityRegis();
                          }}
                        />
                      </>
                    )}
                  </div>
                )
              ) : (
                <div className="action_row">
                  <Buttons.BgStandard
                    label={t("Back", { ns: "common" })}
                    onClick={this.handleClickBack}
                  />
                </div>
              )}
            </>
          )}
          {activityRegisData && activityRegisData.length > 0 && (
            <div className="member_registed_layout">
              <div className="mbr_title">
                {t("List of Participants", { ns: "common" })}
              </div>
              {activityRegisData.map((e, i) => (
                <div key={i} className="mbr_item_wrap">
                  <Cards.CustomerActFRegisItem
                    {...e}
                    no={i + 1}
                    isClosedRegistration={isClosedRegistration}
                    is_edit_request_active={data.is_edit_request_active}
                    onApproveAdminEdit={() => this.handleApproveAdminEdit(e)}
                    onView={() => this.handleEdit("view", e)}
                    onEdit={() => this.handleEdit("update", e)}
                    onEditDataRequest={() => this.handleEditDataRequest(e)}
                    onResumeEdit={() => this.handleEdit("update", e)}
                    onShowQrCode={() => this.handleShowQrCode(e)}
                    onDelete={() => this.handleDelete(e)}
                  />
                </div>
              ))}
            </div>
          )}
        </div>
        <Modals.BodyEmpty
          isShowModal={isShowModal}
          onCloseModal={this.handleCloseModal}
        >
          {renderModal}
        </Modals.BodyEmpty>
      </ActivitiesFormDetailContainerStyled>
    );
  }
}

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = (dispatch) => ({
  setReduxWallet: (data) => dispatch(setReduxWallet(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  withTranslation(["common", "profile"])(
    withRouter(ActivitiesFormDetailContainer),
  ),
);
